import { modulesAtom } from "atoms/GlobalAtoms";
import { useAtomValue } from "jotai";
import { useRef, useCallback } from "react";
import _ from "underscore";
import { generateFieldMap } from "./useFieldMap";

// useFieldMaps - uses same logic from useFieldMap - (generateFieldMap function) but returns a function
// This allows the user to use the returned function for any moduleAPIName.
// Useful when you are looping over data/fields that are from different modules.
// This hook also caches module lookups and maps to improve speed.
const useFieldMaps = ({ value, separateSubitem = false }) => {
  const modules = useAtomValue(modulesAtom);
  const foundModules = useRef({});
  const cachedMaps = useRef({});

  const getFieldMap = useCallback(
    (moduleAPIName) => {
      let mod = foundModules.current[moduleAPIName];

      if (!mod) {
        mod = _.findWhere(modules, { APIName: moduleAPIName });

        if (!mod) return {};

        foundModules.current[moduleAPIName] = mod;
      }

      let mapKey = `${moduleAPIName}_${value}_${separateSubitem}`;

      let map = cachedMaps.current[mapKey];

      if (!map) {
        map = generateFieldMap(mod?.Fields, "APIName", value, separateSubitem);

        cachedMaps.current[mapKey] = map;
      }

      return map;
    },
    [modules, value, separateSubitem]
  );

  return { getFieldMap };
};

export default useFieldMaps;
